import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import React, { useState } from 'react'
import ACDSortingTable from './ACDSortingTable'
import ACDTab from './ACDTab'
import ACDEvaluationList from './ACDEvaluationList'
import { useLocation } from 'react-router-dom'
import { Box } from '@mui/material'

const ACDTabs = ({
  cycleName,
  status_name,
  start_date,
  end_date,
  description,
  isLoading,
  totalEvaluations,
  totalParticipants,
}) => {
  const { pathname, state } = useLocation()
  const appraisalId = pathname.split('/').pop()
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'gray-line.main',
        borderRadius: '4.5px',
        bgcolor: 'white.main',
      }}
    >
      <AdxTabsBadge
        initialValue={state?.initialTabsValue || 0}
        scrollButtons={false}
        tabsBorderBottom
      >
        <AdxTabsPanel label="Details">
          <ACDTab
            status_name={status_name}
            start_date={start_date}
            end_date={end_date}
            description={description}
            isLoading={isLoading}
          />
        </AdxTabsPanel>
        <AdxTabsPanel notification={totalEvaluations} label="Evaluation">
          <ACDEvaluationList
            appraisalId={appraisalId}
            status_name={status_name}
            cycleName={cycleName}
          />
        </AdxTabsPanel>
        <AdxTabsPanel notification={totalParticipants} label="Participant">
          <ACDSortingTable
            appraisalId={appraisalId}
            status_name={status_name}
            cycleName={cycleName}
          />
        </AdxTabsPanel>
      </AdxTabsBadge>
    </Box>
  )
}

export default ACDTabs
